import React, { ChangeEvent } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';

interface IKeyPickupStatus {
  label: string;
  value: string;
}

export const KEY_PICKUP_SERVICE_REQUEST_STATUSES: IKeyPickupStatus[] = [
  { label: 'Resolved', value: 'Resolved' },
  { label: 'Closed', value: 'Closed' },
  { label: 'Under Review', value: 'Under Review' },
];

interface ServiceRequestStatusDropdownProps {
  serviceRequest: IServiceRequest;
  handleStatusChange: (status: { name: string }, id: string) => void;
  isDisabled?: boolean;
}

const ServiceRequestStatusDropdown = ({
  serviceRequest,
  handleStatusChange,
  isDisabled = false,
}: ServiceRequestStatusDropdownProps) => {
  const activeStatus: string = serviceRequest.status || '';

  return (
    <>
      <div style={{ display: 'inline-block' }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <select
            value={activeStatus}
            className={`button button--tiny button--outline-teal ${isDisabled ? 'loading-select' : ''}`}
            onChange={(e: ChangeEvent<HTMLSelectElement>) => {
              handleStatusChange({ name: e.target.value }, serviceRequest.id);
            }}
            disabled={isDisabled}
            style={{
              opacity: isDisabled ? 0.7 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              paddingRight: isDisabled ? '30px' : '12px',
            }}
          >
            {KEY_PICKUP_SERVICE_REQUEST_STATUSES.findIndex(
              (a) => a.value === activeStatus
            ) === -1 && (
              <option value={activeStatus} disabled>
                {activeStatus}
              </option>
            )}
            {isDisabled ? (
              <option value={activeStatus} disabled>
                Updating...
              </option>
            ) : (
              KEY_PICKUP_SERVICE_REQUEST_STATUSES.map(
                (status: IKeyPickupStatus, index: number) => (
                  <option key={index} value={status.value}>
                    {status.label}
                  </option>
                )
              )
            )}
          </select>
          {isDisabled && (
            <span
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            >
              <FontAwesomeIcon glyph="spinner" weight="regular" size="small" />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default ServiceRequestStatusDropdown;
